/* Cart drawer behavior.
   - Opens itself after any `cart:updated` event whose source is an add.
   - Swaps its own content from the bundled Section Rendering API HTML that
     dotto.js requests with every cart mutation.
   - Handles quantity steppers, removals, and quick-add buttons by delegation
     (content is replaced wholesale, so no per-node listeners). */

class CartDrawer extends window.Dotto.OverlayElement {
  connectedCallback() {
    super.connectedCallback();
    this.sectionId = this.dataset.sectionId;
    if (!window.Dotto.cartSections.includes(this.sectionId)) {
      window.Dotto.cartSections.push(this.sectionId);
    }

    document.addEventListener('cart:updated', (event) => {
      const { sections, source } = event.detail || {};
      if (sections && sections[this.sectionId]) this.renderFrom(sections[this.sectionId]);
      this.syncHeaderCount();
      if (source === 'add') this.open();
    });

    this.addEventListener('click', (event) => this.onClick(event));
    this.addEventListener('change', (event) => {
      const input = event.target.closest('[data-quantity-input]');
      if (input) {
        this.changeLine(input.closest('[data-line]'), parseInt(input.value, 10) || 0);
        return;
      }
      const note = event.target.closest('[data-cart-note]');
      if (note) {
        fetch(`${window.Dotto.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value }),
        }).catch(() => {});
      }
    });
  }

  onClick(event) {
    const step = event.target.closest('[data-quantity-change]');
    if (step) {
      const line = step.closest('[data-line]');
      const input = line.querySelector('[data-quantity-input]');
      const next = (parseInt(input.value, 10) || 0) + parseInt(step.dataset.quantityChange, 10);
      this.changeLine(line, Math.max(0, next));
      return;
    }
    const remove = event.target.closest('[data-remove-item]');
    if (remove) {
      this.changeLine(remove.closest('[data-line]'), 0);
    }
    // Cross-sell adds ([data-quick-add-variant]) are handled globally by quick-add.js.
  }

  async changeLine(lineEl, quantity) {
    if (!lineEl) return;
    lineEl.style.opacity = '0.5';
    try {
      await window.Dotto.cartChange(parseInt(lineEl.dataset.line, 10), quantity);
    } catch (error) {
      lineEl.style.opacity = '';
    }
  }

  renderFrom(html) {
    const incoming = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('[data-cart-drawer-content]');
    const target = this.querySelector('[data-cart-drawer-content]');
    if (incoming && target) target.replaceWith(incoming);
  }

  syncHeaderCount() {
    const marker = this.querySelector('[data-cart-item-count]');
    if (!marker) return;
    const count = marker.dataset.cartItemCount;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.childNodes[0].nodeValue = count;
      el.classList.toggle('is-empty', count === '0');
    });
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
